<div class="modal-section form-row user-select-none">
    <ycn-base-autocomplete
        [placeholder]="'Search for Info'"
        [searchType]="this.infoType + '_info_field'"
        [buttonType]="'icon-search'"
        [defaultOnly]="defaultOnly"
        (submitHandler)="autoSelectInfoField($event)">
    </ycn-base-autocomplete>
</div>

<ycn-loading-symbol *ngIf="loading; else showMenu" [loaderMessage]="'Loading...'"></ycn-loading-symbol>
<ng-template #showMenu>
    <div class="modal-section linked-lists user-select-none">
        <!-- Category -->
        <div class="linked-list">
            <div class="linked-list-header">Category</div>
            <div class="linked-list-body">
                <div class="linked-list-item"
                     *ngFor="let category of categories"
                     [ngClass]="{selected: category.name === selectedCategoryName}">
                    <div class="linked-list-item-header"
                         (click)="selectCategoryByName(category.name)"
                         [id]="category.name">
                        <span [textContent]="category.name"></span>
                    </div>
                </div>
            </div>
        </div>
        <!-- Item -->
        <div class="linked-list">
            <div class="linked-list-header">Item</div>
            <div class="linked-list-body linked-list-sublist">
                <div class="linked-list-item"
                     *ngFor="let infoField of categoryInfoFieldsMap[this.selectedCategoryName]">
                    <div class="linked-list-item-header"
                         (click)="selectHandler.emit(infoField)">
                        <span [textContent]="infoField.name"></span>
                        <div class="linked-list-item-controls"
                             *ngIf="selectedInfoFieldsMap[infoField.key]">
                            <div class="btn btn-xs btn-circle btn-transparent btn-check">
                                <svg ycnIcon [name]="'icon-check'"></svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
